import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        actionRow: {
            '& > button': {
                marginLeft: 'auto'
            },
            justifyContent: 'flex-end',
            height: '100%',
            paddingTop: '10px'
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            }
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px'
            },
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px 24px'
        },
        buttonBack: {
            '&.MuiButton-root': {
                border: `1px solid ${colors[mode].primaryText}`,
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: colors[mode].primaryText,
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                textTransform: 'uppercase',
                width: '65px',
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)'
            }
        },
        buttonSubmit: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                border: '1px solid #FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                fontFamily: 'Roboto',
                fontFeatureSettings: '"liga" off, "clig" off',
                fontSize: '12px',
                fontWeight: 400,
                height: '32px',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                marginLeft: '10px',
                padding: '8px 16px',
                textTransform: 'uppercase',
                width: 'auto'
            },
            '&:disabled': {
                borderColor: 'rgba(0, 0, 0, 0.12)',
                opacity: '0.5'
            }
        },
        cannotScanContainer: {
            paddingTop: '20px'
        },
        cantScanContainer: {
            display: 'contents'
        },
        content: {
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            fontSize: '20px'
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        fieldsContainer: {
            '@media screen and (max-width: 320px)': {
                alignItems: 'start'
            },
            alignItems: 'center',
            backgroundColor: colors[mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            minHeight: '190px',
            padding: '16px 24px'
        },
        show: {
            display: 'block'
        },
        hide: {
            display: 'none'
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        root: {
            padding: theme.spacing(0, 2, 2, 2)
        },
        stepper: {
            width: '50%',
            margin: 'auto'
        },
        stepperContainer: {
            width: '100%'
        },
        secretContainer: {
            color: colors[mode].primaryText,
            fontFamily: 'Roboto',
            fontSize: '24px',
            fontWeight: '400',
            lineHeight: '32px',
            letterSpacing: '-0.5px',
            textAlign: 'center',
        },
        verbiage: {
            backgroundColor: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            whiteSpace: 'pre-line'
        },
        warningLine: {
            background: colors[mode].primaryBackground,
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontFeatureSettings: '"liga" off, "clig" off',
            fontSize: '14px',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            padding: '32px 24px'
        }
    }
}
export default styles
